import React, { Fragment } from 'react';
import { Button, Grid, Modal } from "semantic-ui-react";

interface ConfirmCancelDialogProps {
    isOpen: boolean,
    onDiscard: () => void;
    onCancel: () => void;
}

const ConfirmCancelDialog = ({ isOpen, onCancel, onDiscard }: ConfirmCancelDialogProps) => {
    return (
        <Fragment>
            <Modal
                onClose={() => onCancel()}
                open={isOpen}
                dimmer={{ className: "test-dimmer" }}
                size={"tiny"}
                closeOnDimmerClick={false}
            >
                <Modal.Content>
                    <Grid divided='vertically'>
                        <Grid.Row>
                            <label style={
                                {
                                    display: "flex",
                                    justifyContent: "center",
                                    width: "100%"
                                }}>
                                Info
                            </label>
                        </Grid.Row>

                        <Grid.Row style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            margin: "10px"
                        }}>
                            Do you want to discard this draft?
                        </Grid.Row>

                        <Grid.Row>
                            <Button
                                className="button-search"
                                style={{ width: "100%", margin: "0.5rem" }}
                                onClick={() => onDiscard()}
                                primary
                                >
                                Discard
                            </Button>
                            <Button
                                className="button-search"
                                style={{ width: "100%", margin: "0.5rem" }}
                                onClick={() => onCancel()}>
                                Cancel
                            </Button>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
            </Modal>
        </Fragment >

    );
};

export default ConfirmCancelDialog;
